(function () {
  if (window.OrionPersonalizationOptions) return;

  var ENDPOINT = '/apps/pricing-preview/personalization-options';
  var requests = {};
  var payloads = {};

  function toProductGid(identity) {
    var value = identity && (identity.gid || identity.productGid || identity.id || identity.productId);
    if (!value) return '';
    return String(value).indexOf('gid://shopify/Product/') === 0 ? String(value) : 'gid://shopify/Product/' + String(value);
  }

  function load(identity) {
    var productGid = toProductGid(identity);
    if (!productGid) return Promise.resolve({ ok: false, product: null, options: [] });
    if (payloads[productGid]) return Promise.resolve(payloads[productGid]);
    if (requests[productGid]) return requests[productGid];
    var url = ENDPOINT + '?product_gid=' + encodeURIComponent(productGid);
    requests[productGid] = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    }).then(function (payload) {
      if (!payload || payload.ok === false) throw new Error('Invalid personalization options payload');
      payload.ok = true;
      payloads[productGid] = payload;
      return payload;
    }).catch(function (error) {
      delete requests[productGid];
      if (/localhost|127\.0\.0\.1/.test(window.location.hostname) && window.console) {
        console.error('[Orion options] App Proxy unavailable', error);
      }
      return { ok: false, product: null, options: [] };
    });
    return requests[productGid];
  }

  function sameId(left, right) {
    if (left == null || right == null || String(left) === '' || String(right) === '') return false;
    function portable(value) { return String(value).replace(/^gid:\/\/shopify\/(?:ProductVariant|Product)\//, ''); }
    return portable(left) === portable(right);
  }

  function arrayForProduct(payload, identity) {
    var wanted = identity || {};
    if (payload && payload.product && Array.isArray(payload.options)) return payload.options.slice();
    var products = payload && payload.products && typeof payload.products === 'object' ? payload.products : {};
    var keys = [wanted.handle, wanted.productHandle, wanted.id, wanted.productId].filter(Boolean);
    for (var index = 0; index < keys.length; index += 1) {
      var direct = products[keys[index]] || products[String(keys[index])];
      if (Array.isArray(direct)) return direct.slice();
      if (direct && Array.isArray(direct.associations)) return direct.associations.slice();
      if (direct && Array.isArray(direct.options)) return direct.options.slice();
    }
    var all = Array.isArray(payload && payload.associations)
      ? payload.associations
      : Array.isArray(payload && payload.options) ? payload.options : [];
    return all.filter(function (item) {
      var wantedHandle = String(wanted.handle || wanted.productHandle || '');
      var itemHandle = String(item.productHandle || item.product_handle || item.mainProductHandle || item.main_product_handle || '');
      return sameId(item.productId || item.product_id || item.mainProductId || item.main_product_id || item.shopifyProductId, wanted.id || wanted.productId) ||
        (wantedHandle && itemHandle === wantedHandle);
    });
  }

  window.OrionPersonalizationOptions = {
    endpoint: ENDPOINT,
    load: load,
    getForProduct: function (payload, identity) {
      return arrayForProduct(payload, identity).filter(function (item) { return item && item.active !== false && item.enabled !== false; });
    },
    sameId: sameId,
    clearCache: function () { requests = {}; payloads = {}; }
  };
})();
